const LocalApp = () => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    Please don&apos;t save the html and then not run it locally.
    <br />
    We have already autosave feature, use Picsart projects instead
  </div>
);

export default LocalApp;
